/**
 * External dependencies.
 */
import { assign, has, isEmpty } from 'lodash';

/**
 * Internal dependencies.
 */
import { getBackgroundStyle, getTextStyle, updateBlock, addStyleTag } from '../../extensions/custom-styles';

function styling( props, selector = false, attributes = false ) {
	const { blockAdvanceOptions } = attributes ? attributes : props.attributes;
	let css = '';
	selector = selector ? selector : `.gutenify-section-${ props.clientId }`;

	css += getBackgroundStyle( blockAdvanceOptions, selector );
	css += getTextStyle( blockAdvanceOptions, selector );

	css += `${ selector }:hover {
		${ has( blockAdvanceOptions, 'hoverTextColor' ) && ! isEmpty( blockAdvanceOptions.hoverTextColor ) ? `color: ${ blockAdvanceOptions.hoverTextColor };` : '' }
		${ has( blockAdvanceOptions, 'hoverBackgroundColor' ) && ! isEmpty( blockAdvanceOptions.hoverBackgroundColor ) ? `background-color: ${ blockAdvanceOptions.hoverBackgroundColor };` : '' }
		${ has( blockAdvanceOptions, 'hoverBackgroundGradient' ) && ! isEmpty( blockAdvanceOptions.hoverBackgroundGradient ) ? `background: ${ blockAdvanceOptions.hoverBackgroundGradient };` : '' }
		${ has( blockAdvanceOptions, 'hoverBorderColor' ) && ! isEmpty( blockAdvanceOptions.hoverBorderColor ) ? `border-color: ${ blockAdvanceOptions.hoverBorderColor };` : '' }
	}`;

	css += `${ selector } {
		${ has( blockAdvanceOptions, 'borderColor' ) && ! isEmpty( blockAdvanceOptions.borderColor ) ? `border-color: ${ blockAdvanceOptions.borderColor };` : '' }
		${ blockAdvanceOptions.borderWidth ? `border-width: ${ blockAdvanceOptions.borderWidth }px;` : '' }
		${ blockAdvanceOptions.borderWidth ? `border-style: solid;` : '' }
		${ blockAdvanceOptions.borderRadius ? `border-radius: ${ blockAdvanceOptions.borderRadius };` : '' }
	}`;

	// Item style.
	const innerBlockSelector = `${ selector } .gutenify-gallery-carousel-item`;
	css += getBackgroundStyle( blockAdvanceOptions.innerBlock, innerBlockSelector );
	css += getTextStyle( blockAdvanceOptions.innerBlock, `${ innerBlockSelector } .gutenify-slider-title, ${ innerBlockSelector } .gutenify-slider-content` );

	css += `${ innerBlockSelector }:hover {
		${ has( blockAdvanceOptions, 'innerBlock.hoverTextColor' ) && ! isEmpty( blockAdvanceOptions.innerBlock.hoverTextColor ) ? `color: ${ blockAdvanceOptions.innerBlock.hoverTextColor };` : '' }
		${ has( blockAdvanceOptions, 'innerBlock.hoverBackgroundColor' ) && ! isEmpty( blockAdvanceOptions.innerBlock.hoverBackgroundColor ) ? `background-color: ${ blockAdvanceOptions.innerBlock.hoverBackgroundColor };` : '' }
		${ has( blockAdvanceOptions, 'innerBlock.hoverBackgroundGradient' ) && ! isEmpty( blockAdvanceOptions.innerBlock.hoverBackgroundGradient ) ? `background: ${ blockAdvanceOptions.innerBlock.hoverBackgroundGradient };` : '' }
		${ has( blockAdvanceOptions, 'innerBlock.hoverBorderColor' ) && ! isEmpty( blockAdvanceOptions.innerBlock.hoverBorderColor ) ? `border-color: ${ blockAdvanceOptions.innerBlock.hoverBorderColor };` : '' }
	}`;

	css += `
	${ innerBlockSelector } {
		${ has( blockAdvanceOptions, 'innerBlock.borderColor' ) && ! isEmpty( blockAdvanceOptions.innerBlock.borderColor ) ? `border-color: ${ blockAdvanceOptions.innerBlock.borderColor };` : '' }
		${ has( blockAdvanceOptions, 'innerBlock.borderWidth' ) && ! isEmpty( blockAdvanceOptions.innerBlock.borderWidth ) ? `border-width: ${ blockAdvanceOptions.innerBlock.borderWidth }px;` : '' }
		${ has( blockAdvanceOptions, 'innerBlock.borderWidth' ) && ! isEmpty( blockAdvanceOptions.innerBlock.borderWidth ) ? `border-style: solid;` : '' }
		${ has( blockAdvanceOptions, 'innerBlock.borderRadius' ) && ! isEmpty( blockAdvanceOptions.innerBlock.borderRadius ) ? `border-radius: ${ blockAdvanceOptions.innerBlock.borderRadius };` : '' }
	}
	`;

	// Button style.
	const buttonBlockSelector = `${ selector } .wp-block-button__link`;
	css += getBackgroundStyle( blockAdvanceOptions.buttonBlock, buttonBlockSelector );
	css += getTextStyle( blockAdvanceOptions.buttonBlock, buttonBlockSelector );

	css += `${ buttonBlockSelector }:hover {
		${ has( blockAdvanceOptions, 'buttonBlock.hoverTextColor' ) && ! isEmpty( blockAdvanceOptions.buttonBlock.hoverTextColor ) ? `color: ${ blockAdvanceOptions.buttonBlock.hoverTextColor };` : '' }
		${ has( blockAdvanceOptions, 'buttonBlock.hoverBackgroundColor' ) && ! isEmpty( blockAdvanceOptions.buttonBlock.hoverBackgroundColor ) ? `background-color: ${ blockAdvanceOptions.buttonBlock.hoverBackgroundColor };` : '' }
		${ has( blockAdvanceOptions, 'buttonBlock.hoverBackgroundGradient' ) && ! isEmpty( blockAdvanceOptions.buttonBlock.hoverBackgroundGradient ) ? `background: ${ blockAdvanceOptions.buttonBlock.hoverBackgroundGradient };` : '' }
		${ has( blockAdvanceOptions, 'buttonBlock.hoverBorderColor' ) && ! isEmpty( blockAdvanceOptions.buttonBlock.hoverBorderColor ) ? `border-color: ${ blockAdvanceOptions.buttonBlock.hoverBorderColor };` : '' }
	}`;

	css += `
	${ buttonBlockSelector } {
		${ has( blockAdvanceOptions, 'buttonBlock.borderColor' ) && ! isEmpty( blockAdvanceOptions.buttonBlock.borderColor ) ? `border-color: ${ blockAdvanceOptions.buttonBlock.borderColor };` : '' }
		${ has( blockAdvanceOptions, 'buttonBlock.borderWidth' ) && ! isEmpty( blockAdvanceOptions.buttonBlock.borderWidth ) ? `border-width: ${ blockAdvanceOptions.buttonBlock.borderWidth }px;` : '' }
		${ has( blockAdvanceOptions, 'buttonBlock.borderWidth' ) && ! isEmpty( blockAdvanceOptions.buttonBlock.borderWidth ) ? `border-style: solid;` : '' }
		${ has( blockAdvanceOptions, 'buttonBlock.borderRadius' ) && ! isEmpty( blockAdvanceOptions.buttonBlock.borderRadius ) ? `border-radius: ${ blockAdvanceOptions.buttonBlock.borderRadius };` : '' }
	}
	`;

	return css;
}

const updateBlockStyle = ( data, props ) => {
	const attrs = assign( props.attributes, data );
	const css = styling( props, false, attrs );

	updateBlock( data, css, props );

	// Admin.
	const adminCss = styling( props, `#block-${ props.clientId }  > *` );
	addStyleTag( props, adminCss, `gutenify-block-${ props.clientId }-main`, true );
};

export { updateBlockStyle };
export default styling;

